<template>
  <div>
    <div v-if="transactions.length === 0" class="panel-body">
      <div class="alert alert-info alert-dismissible" role="alert">
        {{ emptyTransactionsMessage }}
      </div>
    </div>
    <div v-if="transactions.length > 0" class="table-responsive top-margin">
      <table class="table table-striped bank-accounts table-fundings">
        <thead>
          <tr>
            <th class="text-center">Transaction number</th>
            <th class="text-center">Note number</th>
            <th class="text-right">Amount</th>
            <th class="text-center">Transaction date</th>
            <th class="text-center">Last update date</th>
            <th class="text-center">Status</th>
            <th class="text-center">View details</th>
            <th class="text-center">{{ actionName }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="transaction in transactions" v-bind:key="transaction.id">
            <td class="text-center">{{ transaction.transactionId }}</td>
            <td class="text-center">{{ transaction.noteId }}</td>
            <td class="text-right">{{ formatAmount(transaction.amount) }}</td>
            <td class="text-center">{{ formatDate(transaction.createdAt) }}</td>
            <td class="text-center">{{ formatDate(transaction.updatedAt) }}</td>
            <td class="text-center">
              <span
                class="label label-danger"
                v-if="transaction.status == 'CANCELLED'"
                >cancelled</span
              >
              <span
                class="label label-danger"
                v-if="transaction.status == 'FAILED'"
                >failed</span
              >
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-details btn-outline"
                v-on:click="goToViewDetail(transaction.id)"
              >
                View details
              </button>
            </td>
            <td class="text-center">
              <button
                type="button"
                class="btn btn-details btn-outline"
                v-on:click="handleArchiveUnarchiveTransaction(transaction)"
              >
                {{ actionName }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { formatDate, formatAmount } from '@/util';

const mix = {
  methods: {
    formatDate,
    formatAmount,
  },
};
export default {
  name: 'FailedTransactionTabView',
  props: {
    actionName: { required: true },
    emptyTransactionsMessage: { required: true },
    transactions: { required: true },
    goToViewDetail: { required: true },
    handleArchiveUnarchiveTransaction: { required: true },
  },
  mixins: [mix],
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}

th {
  padding: 14px 8px;
  color: #888;
  border-bottom-width: 1px;
  vertical-align: bottom;
  border-bottom: 1px solid #eee;
  border-top: 0;
  line-height: 1.52857143;
  font-weight: normal;
}

td {
  padding: 8px;
  line-height: 1.52857143;
  vertical-align: top;
  border-top: 1px solid #eee;
}

.table-striped > tbody > tr:nth-of-type(odd) {
  background-color: #fafbfc;
}
</style>



// WEBPACK FOOTER //
// FailedTransactionTabView.vue?c22491b8